import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { Box, Stack, Typography, useTheme } from '@mui/material'
import { InnerHtml, Loading } from 'components/ui'
import { useDateTime, useMappedTranslation, usePageTitle } from 'hooks'

import {
  detailContainerStyle,
  detailContentBoxStyle,
  detailDateTextStyle,
  detailDescriptionStyle,
  detailInfoBoxStyle,
  detailInfoStackStyle,
  detailTitleBoxStyle,
  detailTitleTypographyStyle
} from './styled'

type Props = {
  notice: {
    id: string
    title: string
    uri: string
    description: string
    published: string
  }
  currentVersion: string
  isLoading: boolean
}

export default function Detail({ notice, currentVersion, isLoading }: Props) {
  const t = useMappedTranslation()
  usePageTitle(notice?.title)

  const navigate = useNavigate()
  const dateTime = useDateTime()
  const theme = useTheme()

  useEffect(() => {
    if (notice === undefined) {
      navigate('/notices', { replace: true })
    }
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <Box sx={detailContainerStyle}>
      <Box sx={detailContentBoxStyle}>
        <Box sx={detailTitleBoxStyle}>
          <Typography variant='h1' sx={detailTitleTypographyStyle}>
            {notice.title || ' '}
          </Typography>
        </Box>
        {isLoading ? (
          <Loading fullScreen />
        ) : (
          <>
            <Box sx={detailInfoBoxStyle}>
              <Stack sx={detailInfoStackStyle}>
                <Typography variant='label1' className='off' sx={detailDateTextStyle}>
                  {t('notice.registrationDate')}: {dateTime(Number(notice.published))}
                </Typography>
                <Link to={currentVersion === 'NEW' ? '/notices' : '/notices/legacies'} data-testid='Link90D1E52B'>
                  <Typography variant='body1'>( {t('notice.previous.button')} )</Typography>
                </Link>
              </Stack>
              <InnerHtml sx={detailDescriptionStyle(theme)}>{notice.description}</InnerHtml>
            </Box>
          </>
        )}
      </Box>
    </Box>
  )
}
